import React, { Children, useEffect, useRef, useState } from "react";
import { addFaq, updateFaq } from "../../actions/utilitiesAction";
import constant from "../../constant";
import QualificationLists from "../../component/jobs/QualificationList";
import { archiveEducationQualification, archiveRole, createEducationQualification, roleList, updateEducationQualification } from "../../actions/JobsAction";
import QuestionLists from "../../component/jobs/QuestionList";
import RoleLists from "../../component/jobs/RoleList";
import queryString from "query-string"
import { useLocation } from "react-router-dom";

const RoleList = () => {
    const [roleLists, setRoleLists] = useState([]);
    const [currentPage, setCurrentPage] = useState(1)
    const [count, setCount] = useState(0)
    const location = useLocation()

    useEffect(() => {
        const qParams = queryString.parse(location.search)
        getRolList(qParams?.p ? qParams.p : qParams?.pageno ? qParams.pageno : currentPage);
        document.title = constant.title.RoleList
    }, [currentPage]);


    const getRolList = (page) => {
        roleList({ pageNumber: page })
            .then((res) => {
                if (res.status) {
                    setRoleLists(res.result.list);
                    setCount(res.result.count)
                }
            })
            .catch((err) => {
                alert(err);
            });
    };

    const updateStatus = (model) => {
        archiveRole(model)
            .then((res) => {
                if (res.status) {
                    getRolList(currentPage);
                }
            })
            .catch((err) => {
                alert(err);
            });
    }

    return (
        <React.Fragment>
            <RoleLists
                roleLists={roleLists}
                updateStatus={updateStatus}
                getRolList={(page => getRolList(page))}
                count={count} setPage={setCurrentPage}
                cpage={currentPage}
            />

        </React.Fragment>
    )
}

export default RoleList;